
import '../styles/auth.scss';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AnimatePresence } from 'framer-motion';
import Logo from '../assets/images/Brolly Logo.svg';

const pathname = window.location.pathname;

const getPageText = (pathname: string) => {
  let text = '';

  switch (pathname) {
    // case '/forgot-password':
    //   return (text = 'Forgot Password');

    case '/reset-password':
      return (text = 'Set Password');

    case '/complete-account':
      return (text = 'Complete Account');

    default:
      break;
  }

  return text;
};

function AuthLayout() {

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 dark:from-gray-900 dark:to-gray-800 p-4 sm:p-6 md:p-8 lg:p-10">
      <div className="container mx-auto">
        <div className="min-h-[calc(100vh-2rem)] flex flex-col items-center justify-center py-8">
          <div className="w-full max-w-md">
            <div className="flex justify-center mb-4 sm:mb-6">
              <img 
                src={Logo} 
                alt="Logo" 
                className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24" 
              />
            </div>

            <motion.h1
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white tracking-tight leading-tight text-center mb-6 sm:mb-8"
            >
              {getPageText(pathname)}
            </motion.h1>

            <div className="w-full">
              <AnimatePresence mode="wait">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -20 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  className="bg-white dark:bg-gray-800 rounded-xl sm:rounded-2xl shadow-md sm:shadow-xl p-4 sm:p-6 md:p-8 border border-gray-100 dark:border-gray-700 w-full"
                >
                  <div className="space-y-4 sm:space-y-6">
                    <Outlet />
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AuthLayout;
